import React from 'react';
import { motion } from 'framer-motion';
import { content } from '../data/content';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Career = () => {
  return (
    <section id="career" className="py-20 md:py-32 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-6">
          <div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">Career Highlights</h2>
            <div className="w-16 h-1 bg-slate-500"></div>
          </div>
          <p className="text-slate-400 max-w-md text-sm md:text-base">
            A track record of delivering complex transformations for leading financial institutions across Europe and Asia.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {content.highlights.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="relative group"
            >
              <div className="absolute top-0 left-0 w-1 h-full bg-slate-700 group-hover:bg-white transition-colors duration-300"></div>
              <div className="pl-8 py-4">
                <div className="mb-2">
                  <span className="text-xs font-bold tracking-wider text-slate-400 uppercase">{item.context}</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{item.role}</h3>
                <p className="text-slate-300 leading-relaxed text-sm">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-20 p-8 md:p-12 bg-slate-800 rounded-2xl flex flex-col md:flex-row gap-8 items-center justify-between">
          <div className="flex-1">
            <h3 className="text-2xl font-serif font-bold mb-2">Ready for the next challenge?</h3>
            <p className="text-slate-400">Available for interim leadership and advisory roles.</p>
          </div>
          <a
            href={content.contact.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white text-slate-900 rounded-md font-medium hover:bg-slate-200 transition-colors"
          >
            <SafeIcon icon={FiIcons.FiLinkedin} />
            Connect on LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
};

export default Career;